import { useEffect, useRef, useState } from "react"
import { Dcs0201Service } from "../../../services/dcs/Dcs0201Service"
import { Tree } from 'primereact/tree';
import { classNames } from "primereact/utils";
import { useAppDispatch } from "../../../store/hook";
import { showAndHideSpinner } from "../../../reducers/spinnerSlice";
import { Constant } from "../../../constants/constant";
import { Dropdown } from "primereact/dropdown";
import { useTranslation } from "react-i18next";
import Dcs0301Service from "../../../services/dcs/Dcs0301Service";
import Dcs0201Form from "./Dcs0201Form";
import { toast, ToastContainer } from "react-toastify";
import "./Dcs0201Style.css"
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { randomInt } from "crypto";
import { VariablesConstant } from "../../../constants/variables";
import DataMappingForm from "./DataMappingForm";
import saveAs from "file-saver";
import Swal from "sweetalert2";
import DataMappingTable from "./DataMappingTable";

// export class Dcs0201Search {
//     dataMapNm?: any;
//     connType?: any;
//     page: number;
//     size: number;
//     constructor(dataMapNm: any, connType: any, page: number, size: number) {
//         this.dataMapNm = dataMapNm;
//         this.connType = connType;
//         this.page = page;
//         this.size = size;
//     }
// }
export class Dcs0201Search {
    dataMapName?: any;
    protNm?: any;
    constructor(dataMapName: any, protNm: any) {
        this.dataMapName = dataMapName;
        this.protNm = protNm;
    }
}
export default function Dcs0201View() {

    const [lstProtTree, setLstProtTree] = useState([])
    const dispatch = useAppDispatch();
    const [sltDataMap, setSltDataMap] = useState<any>()
    const [connProtLst, setConnProtLst] = useState<any>([]);
    const [protocolSlt, setProtocolSlt] = useState<any>();
    const [modelSearch, setModelSearch] = useState<Dcs0201Search>(new Dcs0201Search("", ""));
    const { t } = useTranslation();
    const [formStatus, setFormStatus] = useState("");
    const [openForm, setOpenForm] = useState<any>(false);
    const [firstLstDataMapping, setFirstLstDataMapping] = useState<any>([])
    const [sltProtVer, setSltProtVer] = useState<any>();
    const [dataMapName, setDataMapName] = useState("")


    useEffect(() => {
        _getLstProtTree()
    }, [modelSearch.dataMapName, modelSearch.protNm])


    function _getLstProtTree() {
        Dcs0201Service.getInstance().getProVerTree(modelSearch).then((res: any) => {
            if (res.data.status) {
                setLstProtTree(res.data.responseData)
            }
        })
    }

    useEffect(() => {
        if (sltDataMap && sltDataMap.dataMapping) {
            setDataMapName(sltDataMap.dataMapName)
            onChangeProtVer(sltDataMap.versionId)
        }
    }, [sltDataMap])

    useEffect(() => {
        getConnProtLst();
    }, []);

    const getConnProtLst = () => {
        Dcs0301Service.getInstance().getList({}).then((res: any) => {
            if (res.data.status) {
                setConnProtLst([{ protNm: "All", value: null }, ...res.data.responseData.data])
            }
        })
    }

    const onClickProVer = (verId:any)=>{
        if(sltProtVer && sltProtVer.protVerId === verId){
            setSltProtVer(null)
            setSltDataMap(null)
        }else{
            onChangeProtVer(verId)
        }
        
    }

    const nodeTemplate = (node: any, options: any) => {

        let label = <b>{node.label}</b>;

        if (!node.children) {
            label = <span className={`tree-item ${sltDataMap && sltDataMap.dataMapId && sltDataMap.dataMapId === node.key && "tree-item-slt"}`} onClick={() => onChangeDataMap(node.key)}>{node.label}</span>;
        }

        return <span className={`${options.className} tree-item ${(sltDataMap && ((sltDataMap.protocolId && sltDataMap.protocolId === node.key) || (sltDataMap.versionId && sltDataMap.versionId === node.key))) ? 'tree-item-slt' : ''} ${node.key === (sltProtVer && sltProtVer.protVerId) ? "tree-item-ver-slt" : ""}`} onClick={() => { (node.level === 2) && onClickProVer(node.key) }}>{label}</span>;
    }

    const togglerTemplate = (node: any, options: any) => {

        if (!node) {
            return;
        }

        const expanded = options.expanded;
        const iconClassName = classNames('p-tree-toggler-icon pi pi-fw', {
            'pi-caret-right': !expanded,
            'pi-caret-down': expanded
        }
        );

        return (
            <button type="button" className="p-tree-toggler p-link" tabIndex={-1} onClick={options.onClick}>
                <span className={iconClassName} aria-hidden="true"></span>
            </button>
        );
    };

    // const onChangeStatus = (status: any, dataMappingId: any) => {
    //     const _lstDataMapping = [...sltDataMap.dataMapping];

    //     _lstDataMapping.forEach((ele: any) => {
    //         if (ele.dataMappingId === dataMappingId) {
    //             ele.status = status
    //         }
    //     })

    //     setSltDataMap({
    //         ...sltDataMap,
    //         dataMapping: _lstDataMapping
    //     })

    // }

    const onChangeDataMap = (dataMapId: any) => {
        if (sltDataMap && sltDataMap.dataMapId === dataMapId) {
            setSltDataMap(null)
        } else {
            dispatch(showAndHideSpinner(true));
            _getLstProtTree()
            Dcs0201Service.getInstance()
                .getDataMapById(dataMapId)
                .then((result: any) => {
                    dispatch(showAndHideSpinner(false));
                    if (result.data.status) {
                        setSltDataMap(result.data.responseData)
                        setFirstLstDataMapping(result.data.responseData.dataMapping)
                    }
                });
        }
    }

    // useEffect(() => {
    //     console.log(sltProtVer);
    //     // console.log(sltProtVer && sltProtVer.toString().includes(VariablesConstant.PROTOCOL_MODBUS_NAME.toUpperCase()));

    // }, [sltProtVer])

    const handleChangeSearchProtocol = (data: any) => {
        setProtocolSlt(data);
        setSltDataMap({})
        setModelSearch({
            ...modelSearch,
            protNm: (data && data.protNm) || '',
        });
    };

    const handleChangeDataMapNm = (event: any) => {
        setModelSearch({
            ...modelSearch,
            dataMapName: event.target.value,
        });
    }

    const search = () => {
        setSltDataMap({})
        _getLstProtTree()
    }

    const reset = () => {
        setSltDataMap(null)
        setProtocolSlt({});
        setModelSearch({
            ...new Dcs0201Search("", ""),
        });
    }

    const closeForm = (isReload: any) => {
        setOpenForm(false)
        if (isReload) {
            onChangeDataMap(sltDataMap.dataMapId)
        }
    }

    const changeStt = (status: any, dataMappingId: any) => {
        dispatch(showAndHideSpinner(true));
        Dcs0201Service.getInstance().changeSttDataMapping({ status: status, dataMappingId: dataMappingId }).then((res: any) => {
            if (res.data.status) {
                Dcs0201Service.getInstance()
                    .getDataMapById(sltDataMap.dataMapId)
                    .then((result: any) => {
                        dispatch(showAndHideSpinner(false));
                        if (result.data.status) {
                            setSltDataMap(result.data.responseData)
                        }
                    });
            } else {
                dispatch(showAndHideSpinner(false));
                toast.error(t("dcs0201.message.err.updateSttFailed"))
            }
        })
    }

    const onChangeProtVer = (verId: any) => {
        lstProtTree.forEach((prot: any) => {
            prot.children.forEach((ver: any) => {
                if (ver.key === verId) {
                    setSltProtVer({
                        protNm: prot.label,
                        protId: prot.key,
                        protVerId: ver.key,
                        protVerNm: ver.label
                    })
                }
            })
        })

    }

    const onClickAdd = () => {
        setSltDataMap({})
    }

    const exportExcel = () => {
        if (sltDataMap) {
            const param = {
                protocolId: sltDataMap.connType,
                protocolName: sltDataMap.protocolName,
                dataMapId: sltDataMap.dataMapId
            }
            Dcs0201Service.getInstance().exportExcelTemplate(param).then((res) => {
                if (res.data) {
                    const blob = new Blob([res.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });
                    saveAs(blob, 'data_mapping_template.xlsx');
                }
            });
        }
    }

    const onCloseForm = (data: any) => {
        setSltProtVer(null);
        if (data) {
            _getLstProtTree()
        }
    }

    const deleteDataMap = (ele: any) => {

        Swal.fire({
            title: t("dcs0201.message.dialog.confirmDelete"),
            showCancelButton: true,
            confirmButtonText: t("dcs0201.btn.delete"),
            cancelButtonText: t("dcs0201.btn.cancel")
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(showAndHideSpinner(true))
                Dcs0201Service.getInstance().deleteDataMap(ele.dataMapId).then((result) => {
                    dispatch(showAndHideSpinner(false))
                    if (result.data.status) {
                        toast.success(t("dcs0201.message.success.deleteDataMap"));
                        setSltDataMap(null);
                        _getLstProtTree()
                    } else {
                        toast.error(t("dcs0201.message.err.deleteDataMap"))
                    }

                })
            }
        });

    }

    const handleChangeDataMapName = (event: any) => {
        setDataMapName(event.target.value)
    }

    const onCloseTable = (data: any) => {
        if (data) {
            _getLstProtTree()
            data.dataMapping ?
                setSltDataMap({
                    ...sltDataMap,
                    dataMapping: data.dataMapping,
                    dataMapName: data.dataMapName
                })
                :
                setSltDataMap(null)
        } else {
            setSltDataMap(null)
        }
    }

    return (
        <>
            <ToastContainer></ToastContainer>
            {
                openForm ? <Dcs0201Form title={formStatus === "C" ? `${t("dcs0201.title.dialog.addDataMap")}` : `${t("dcs0201.title.dialog.dataMapDetail")}`} onClose={closeForm} data={(formStatus === "U") && sltDataMap} />
                    :
                    <>
                        <div className="box">
                            <div className="search-body">
                                <div className="row">
                                    <div className="col-sm-2" style={{ alignContent: "center" }}>
                                        <label className="search-label">
                                            {sltDataMap && sltDataMap.dataMapName}
                                        </label>
                                    </div>
                                    <div className="col-sm-2" style={{ alignContent: "center" }}>
                                        <span>
                                            <label className="search-label">{t("dcs0201.label.protVer")}: </label>
                                            {sltDataMap && sltDataMap.protocolName} - {sltDataMap && sltDataMap.protocolVersion}
                                        </span>
                                    </div>
                                    <div className="col-sm-8">
                                        <div className="d-flex gap-2 align-items-center">
                                            <div className="search-el">
                                                <label className="search-label"> {t("dcs0101.label.connectionProtocol")}</label>
                                                <Dropdown
                                                    value={protocolSlt}
                                                    onChange={(e: any) => handleChangeSearchProtocol(e.value)}
                                                    options={connProtLst}
                                                    placeholder="All"
                                                    // optionLabel={Constant.SOUTH_KOREA === lang ? Constant.COMM_NM_KR : Constant.COMM_NM_EN}
                                                    optionLabel="protNm"
                                                />
                                            </div>
                                            <div className="search-el input-search">
                                                <input
                                                    value={modelSearch.dataMapName || ""}
                                                    className={`form-control`}
                                                    name="dataMapName"
                                                    placeholder={`${t("dcs0201.filter.title.dataMapName")}`}
                                                    onChange={handleChangeDataMapNm}
                                                    onKeyUp={(e: any) => {
                                                        if (e.key === "Enter") search();
                                                    }}
                                                />
                                            </div>
                                            <button type="button" className="custom-btn gradient" onClick={search}>
                                                <i className="pi pi-search me-2"></i> {t("sys0301.label.search")}
                                            </button>
                                            <button type="button" className="custom-btn" onClick={reset}>
                                                <i className="pi pi-refresh me-2"></i> {t("sys0301.label.reset")}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="box">
                            <div className="box-body">
                                <div className="row">
                                    <div className="col-md-3">
                                        {lstProtTree && <Tree style={{ padding: 0 }} value={lstProtTree} nodeTemplate={nodeTemplate} togglerTemplate={togglerTemplate}
                                        ></Tree>}

                                        <div className="d-flex justify-content-end mt-2">
                                            <a className={`n-btn1 d-flex align-items-center justify-content-center ${!sltProtVer && "disabled-ic-btn"}`} onClick={() => { sltProtVer && onClickAdd() }}>
                                                <i className="xi-plus-thin text-black"></i>
                                            </a>
                                        </div>

                                    </div>
                                    <div className="col-md-9">
                                        {sltDataMap && <DataMappingTable data={sltDataMap} onClose={onCloseTable} protVer={sltProtVer} />}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
            }
        </>
    )
}